<template>
    <layout title="Welcome">
       <div>
      <!-- Page title & actions -->
      <div class="px-4 py-4 border-b border-gray-200 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <div class="flex-1 min-w-0">
          <h1 class="text-lg font-medium leading-6 text-gray-900 sm:truncate">
            Schema <span v-if="filtered">- {{filtered}}</span>
          </h1>
        </div>
        <div class="flex mt-4 sm:mt-0 sm:ml-4">
          <span class="rounded-md shadow-sm order-0 sm:order-1 sm:ml-3">
            <!-- <button type="button" class="inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-green-600 border border-transparent rounded-md hover:bg-lightblue-500 focus:outline-none focus:shadow-outline-lightblue focus:border-lightblue-700 active:bg-lightblue-700">
              Campagne starten
            </button> -->
          </span>
        </div>
      </div>
      
      <!-- Projects table (small breakpoint and up) -->
      <div class="hidden sm:block">
        <div class="inline-block min-w-full align-middle border-b border-gray-200">
          <table class="min-w-full">
            <thead>
              <tr class="border-t border-gray-200">
                <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  <span class="lg:pl-2">Deelnemer</span>
                </th>
                <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  <span class="lg:pl-2">Naar</span>
                </th>
                <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Organisatie
                </th>
                <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Template
                </th>
                <th class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  Geplanned op
                </th>
                <th class="py-3 pr-6 text-xs font-medium leading-4 tracking-wider text-right text-gray-500 uppercase border-b border-gray-200 bg-gray-50"></th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-100">
              <tr class="hover:bg-gray-100" v-for="schedule in schedules.data" :key="schedule.id">
                <td @click="openDetails(schedule)" class="px-6 py-3 text-sm font-medium leading-5 text-gray-900 whitespace-nowrap max-w-0">
                  <div class="flex items-center space-x-3 lg:pl-2">
                    <div class="flex-shrink-0 w-2.5 h-2.5 rounded-full bg-green-600"></div>
                    <a href="#" class="truncate hover:text-gray-600">
                        {{ schedule.attendee.name }}
                    </a>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span class="flex-shrink-0 text-xs font-medium leading-5">{{ schedule.attendee.email }}</span>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span class="flex-shrink-0 text-xs font-medium leading-5">{{ schedule.organisation_name }}</span>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span class="flex-shrink-0 text-xs font-medium leading-5">{{ schedule.template_name }}</span>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span class="flex-shrink-0 text-xs font-medium leading-5">{{ schedule.planned_at }}</span>
                  </div>
                </td>
                <td class="pr-6">
                  <div class="relative flex items-center justify-end">
                    <button @click="clickOptionDropdown(schedule.id)" id="project-options-menu-0" aria-has-popup="true" type="button" class="inline-flex items-center justify-center w-8 h-8 text-gray-400 transition duration-150 ease-in-out bg-transparent rounded-full hover:text-gray-500 focus:outline-none focus:text-gray-500 focus:bg-gray-100">
                      <!-- Heroicon name: dots-vertical -->
                      <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                      </svg>
                    </button>
                    <!--
                      Dropdown panel, show/hide based on dropdown state.

                      Entering: "transition ease-out duration-100"
                        From: "transform opacity-0 scale-95"
                        To: "transform opacity-100 scale-100"
                      Leaving: "transition ease-in duration-75"
                        From: "transform opacity-100 scale-100"
                        To: "transform opacity-0 scale-95"
                    -->
                    <div v-if="optionDropdown(schedule.id)" class="absolute top-0 w-48 mx-3 mt-1 origin-top-right rounded-md shadow-lg right-7">
                      <div class="z-10 bg-white rounded-md shadow-xs" role="menu" aria-orientation="vertical" aria-labelledby="project-options-menu-0">
                        <a @click="send(schedule)" class="flex items-center px-4 py-2 text-sm leading-5 text-gray-700 cursor-pointer group hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">
                            <!-- Heroicon name: pencil-alt -->
                            <svg class="w-5 h-5 mr-3 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                              <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
                              <path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" clip-rule="evenodd" />
                            </svg>
                            Stuur nu
                          </a>
                        <div class="border-t border-gray-100"></div>
                        <div class="py-1 cursor-pointer">
                          <a @click="cancel(schedule)" class="flex items-center px-4 py-2 text-sm leading-5 text-gray-700 cursor-pointer group hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:bg-gray-100 focus:text-gray-900" role="menuitem">
                            <!-- Heroicon name: trash -->
                            <svg class="w-5 h-5 mr-3 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                              <path fill-rule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clip-rule="evenodd" />
                            </svg>
                            Verwijder
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      </div>
    
    </layout>
</template>

<script>
  import Layout from '@/Shared/Layout'

  export default {
      layout: Layout,
      props: {
        schedules: Object,
        filtered: String
      },
      data: () => ({
        optionDropdownId: null,
      }),
      methods: {
        optionDropdown(id) {
          return this.optionDropdownId === id;
        },
        clickOptionDropdown(id) {
          if (this.optionDropdownId === id) {
            this.optionDropdownId = null;
          } else {
            this.optionDropdownId = id;
          }
        },
        openDetails(schedule) {
          this.$inertia.visit(schedule.links.show);
        },
        cancel(schedule) {
          this.optionDropdownId = null;
          if (confirm("Weet je zeker dat je deze poging wilt verwijderen?")) {
            this.$inertia.delete(schedule.links.delete, [], {
              replace: true,
              preserveState: false,
              preserveScroll: false,
            });
          }
        },
        send(schedule) {
          this.optionDropdownId = null;
          this.$inertia.post(schedule.links.send, [], {
            replace: true,
            preserveState: false,
            preserveScroll: false,
          });
        }
      }
  }

</script>
